export type DateFormattingInput = Date | string | number | null | undefined;
export function isValidDateFormat(date: string): boolean {
  const dateFormatRegex = new RegExp(
    "^(?:(?:31(\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\.)(?:0?[13-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$",
    "gm",
  );

  return dateFormatRegex.test(date);
}

export function isValidDate(date: string): boolean {
  if (date.length < 10) {
    return false;
  }

  return !Number.isNaN(Date.parse(date));
}

export function calculateLegalAge(date: Date, yearsToSubtract = 18): string {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "Invalid Date Provided";
  }

  const calculatedDate = new Date(date);

  calculatedDate.setFullYear(calculatedDate.getFullYear() - yearsToSubtract);

  return formatDate(calculatedDate);
}

export function setValidDate(
  date: string,
  controlDate: Date,
  addDays: number,
): string {
  if (!isValidDate(date)) {
    return "Invalid date";
  }

  const selectedDate = new Date(date);
  const normalizedControlDate = new Date(controlDate);
  normalizedControlDate.setHours(0, 0, 0, 0);

  selectedDate.setHours(0, 0, 0, 0);

  if (selectedDate.getTime() < normalizedControlDate.getTime()) {
    const adjustedDate = new Date(
      normalizedControlDate.getTime() + addDays * 86_400_000,
    );

    return formatDate(adjustedDate);
  }

  return formatDate(selectedDate);
}
export function getDefaultDate(relativeDate: string): number | undefined {
  const currentDate = new Date();
  const match = relativeDate.match(/(plus|minus)_(\d+)_days/);

  if (!match) {
    return undefined;
  }

  const operation = match[1];
  const numberOfDays = Number(match[2]);

  if (operation === "plus") {
    currentDate.setDate(currentDate.getDate() + numberOfDays);
  } else {
    currentDate.setDate(currentDate.getDate() - numberOfDays);
  }

  return currentDate.setHours(0, 0, 0, 0);
}

export function checkForRelativeDates(
  value: DateFormattingInput | Array<string | Date>,
): DateFormattingInput | Array<string | Date> {
  if (typeof value === "string") {
    const parsedDate = Date.parse(value);

    if (Number.isNaN(parsedDate)) {
      return getDefaultDate(value);
    }

    return value;
  }

  if (Array.isArray(value)) {
    for (const dateItem of value) {
      const parsedDate = Date.parse(String(dateItem));

      if (Number.isNaN(parsedDate)) {
        return getDefaultDate(String(dateItem));
      }

      if (dateItem instanceof Date) {
        return dateItem.setHours(0, 0, 0, 0);
      }

      return dateItem;
    }
  }

  return value;
}

export function formatDate(date: DateFormattingInput, locale = ""): string {
  if (date === undefined || date === null) {
    return "";
  }

  const dateObject = new Date(date);
  const isInvalidDate = Number.isNaN(dateObject.getTime());

  if (isInvalidDate) {
    return "";
  }

  const day = dateObject.getDate();
  const month = dateObject.getMonth() + 1;
  const year = dateObject.getFullYear();

  const formattedDay = day < 10 ? `0${day}` : String(day);
  const formattedMonth = month < 10 ? `0${month}` : String(month);

  if (locale === "de" || locale === "de-informal" || locale === "uk") {
    return `${formattedDay}.${formattedMonth}.${year}`;
  }

  return `${year}-${formattedMonth}-${formattedDay}`;
}

export function swapDateFormats(
  date: string,
  fromSeparator: string,
  toSeparator: string,
): string {
  return date.split(fromSeparator).reverse().join(toSeparator);
}
